import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import Button from '../../Button'

function TableModalButtonDisconnectAll({
  Component = Button.Text,
  textKey = 'Modal.DisconnectAllActionKey',
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <Component
      {...restProps}
      text={t(textKey)}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
    />
  )
}

export default TableModalButtonDisconnectAll
